import * as React from 'react'
import {connect} from "react-redux"
import {CustomerDescriptor} from "../../models/Customer"
import {ApplicationState} from "../../store"
import {actionCustomerFetch} from '../../store/customers/actions'
import {Button, Paper} from '@material-ui/core'
import {actionCustomerSave} from '../../store/customers/actions'
import SaveIcon from "@material-ui/icons/Save"
import {Tab, TabTypes} from '../Tab'
import BaseTab, {BaseTabProps, BaseTabState} from '../BaseTab'
import {Utility} from '../../core/Utility'
import {Validator} from '../../core/Validator'
import {actionActiveTabTitle} from '../../store/tabs/actions'
import ContactsForm from './ContactsForm'
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded"
import DeleteIcon from '@material-ui/icons/Delete'
import {Contact} from '../../models/Contact'
import {actionSetTabState} from '../../store/tabs/actions'
import {PopupDialog} from '../../core/components/PopupDialog'
import {t} from "../../core/localization"
import AssessmentIcon from '@material-ui/icons/Assessment'
import {TabsService} from "../TabsService"
import {AppConfig} from "../../config"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {FieldView} from "../components/FieldView"
import {customerFieldsDescriptor} from "./CustomerFields"

export interface CustomerTabProps extends BaseTabProps {
	tab: Tab
}

export interface CustomerTabState extends BaseTabState {
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active
	}
}

class CustomerTab extends BaseTab<CustomerTabProps, CustomerTabState> {

	constructor(props: CustomerTabProps) {
		super(props);
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: CustomerTabProps) {
	}

	componentDidMount() {
		if (this.props.item && this.props.item.id) {
			if(!this.props.item.contacts)
				actionCustomerFetch(this.props.item)
		}
	}

	buttonSaveClick(){

		let itemToSave = this.getItemFromTabState()
		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, CustomerDescriptor)

		if (validation.valid) {
			actionCustomerSave(itemToSave)
			actionActiveTabTitle(t.Customer + ': ' + this.getItemFromTabState('title'))
		}

		this.setState({ ...this.state, validation: validation });
	}

	addContact(){
		let item = this.getItemFromTabState()

		if(item){

			if(!item['contacts']){
				item['contacts'] = []
				// item['selectedContactNumber'] = undefined
			}
			item['selectedContactNumber'] = item['contacts'].length;

			var contact = new Contact()
			contact.customerId = item.id

			item['contacts'].push(contact);

			let tabState = this.props.state
			tabState['item'] = item
			actionSetTabState(tabState)
		}
	}

	deleteContact(){
		let item = this.getItemFromTabState()

		if(item && item['contacts']){
			let selectedContactNumber = item['selectedContactNumber']
			let contacts = item['contacts']

			if(selectedContactNumber < contacts.length){
				let newContacts = Utility.removeItem(contacts, contacts[selectedContactNumber])
				item['contacts']= newContacts

				if(newContacts.length > 0){
					item['selectedContactNumber'] = undefined
				}

				let tabState = this.props.state
				tabState['item'] = item
				actionSetTabState(tabState)
			}
		}
	}

	financesButtonClick() {
		const customer = this.props.item;
		TabsService.createTab(t.Finances + ': ' + customer.title, TabTypes.CUSTOMER_FINANCES, customer)
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '10px'}}>
				<div style={{display:'flex', flexDirection:"row", flex:"2" }}>
					<div style={{flex:'1', marginRight: "20px"}}>
						<Paper style={{padding:'10px'}}>
							{this.renderForm()}
							{this.renderCustomerControls()}
						</Paper>
					</div>
					<div style={{flex:'1'}}>
						{this.props.item.id &&
						<Paper style={{padding: '10px'}}>
							<Button onClick={this.addContact.bind(this)} color="primary" style={{}}><AddIcon/>{t.CreateNewContact}</Button>
							<ContactsForm />
						</Paper>
						}
						{!this.props.item.id && <p style={{textAlign: 'center'}}>{t.SaveUser}</p>}
					</div>
				</div>
				{this.renderPopupDialog()}
		</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = customerFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	renderCustomerControls(): React.ReactNode {
		return <div style={{textAlign: "right"}}>
			{this.props.item.id && !AppConfig().appearance.clientPageHideFinanceButton && <Button onClick={this.financesButtonClick.bind(this)} variant="contained" color="primary" style={{ marginRight: '10px'}}><AssessmentIcon />{t.Finances}</Button>}
			<Button onClick={this.buttonSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon/>{t.Save}</Button>
		</div>
	}

	renderContactControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
			<Button onClick={this.deleteContact.bind(this)} variant="contained" color="secondary" style={{}}><DeleteIcon />Delete contact</Button>
			<Button onClick={this.buttonSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />Save contact</Button>
		</div>
	}
}

export default connect(mapStateToProps)(CustomerTab);
